export default __webpack_public_path__ + "static/media/data-security.377723fc.svg";